import { Component, OnInit } from '@angular/core';
import { MembersPortalService } from '../../../angular-wallet-base/services/members-portal.service';
import { TranslateService } from '@ngx-translate/core';
import { AppModeService } from '../../../angular-wallet-base/services/app-mode.service';
import { ModalController, Platform, ToastController } from '@ionic/angular';
import { getToastPosition } from '../../../angular-wallet-base/utils';
import { Store } from '@ngrx/store';
import { AppState } from '../../../angular-wallet-base/store/appState';
import { GetUserDevicesRequestAction } from '../../../angular-wallet-base/actions/devicesList.actions';
import { Logger } from 'src/app/angular-wallet-base/services/logger.service';
@Component({
  selector: 'app-list2fa-device',
  templateUrl: './list2fa-device.component.html',
  styleUrls: ['./list2fa-device.component.scss'],
})
export class List2faDeviceComponent implements OnInit {
  public devices: any = [];
  public isDesktopMode: boolean;
  public showRemoveDevice: boolean = false;
  public deviceList: boolean = true;
  public deviceData: any;
  public twofacode;
  public lodeUser;
  public type2fa;
  public loader = false;

  constructor(private membersPortalService: MembersPortalService,
    private translate: TranslateService,
    protected store: Store<AppState>,
    private modal: ModalController,
    public appMode: AppModeService,
    private toast: ToastController,
    private platform: Platform,
  ) {
    this.appMode.isDesktopMode.subscribe(mode => this.isDesktopMode = mode);

  }

  async ngOnInit() {
    this.devices = await this.membersPortalService.getUserDevices();
    this.lodeUser = await this.membersPortalService.getUserInfo();
    this.type2fa = this.lodeUser.two_factor;
  }
  closeModal() {
    this.modal.dismiss();
  }
  async removeAccount(device) {
    if(this.type2fa == 'sms') this.sendDeviceRemoveSms();
    this.deviceList = false;
    this.showRemoveDevice = true;
    this.deviceData = device
  }

  async removeAccountCancel() {
    if (this.isDesktopMode) {
      this.closeModal();
    } else {
      this.deviceList = true;
      this.showRemoveDevice = false;
      this.devices = await this.membersPortalService.getUserDevices();
    
    }
    
  }

  async sendDeviceRemoveSms(){
    try {
      await this.membersPortalService.sendSmsToDisable2FA();
    } catch (error) {
      Logger.info(error)
    }
  }

  async confirmRemoveDevice() {
    this.loader = true;
    try {
      let res = await this.membersPortalService.delete2FADevice(this.twofacode, this.deviceData.unformatted_agent);
      
        this.presentToast('settings.toast_msgs.ok_hdr', 'settings.toast_msgs.remove_device_success_msg');
        this.devices = await this.membersPortalService.getUserDevices();
        this.deviceList = true;
        this.showRemoveDevice = false;
        // this.closeModal()
      this.store.dispatch(new GetUserDevicesRequestAction());
    } catch (err) {
      if(err.error.error == 'sms_otp_mismatch_can_attempt') this.presentToast('settings.toast_msgs.err_hdr', 'settings.toast_msgs.remove_device_err_msg');
      if(err.error.error == 'sms_otp_mismatch_cannot_attempt') this.presentToast('settings.toast_msgs.err_hdr', 'settings.toast_msgs.attepts_over_err_msg');
      this.loader = false;
    }
    this.loader = false;
  }
  async presentToast(hdr, msg) {
    const toast = await this.toast.create({
      header: await this.translate.get(hdr).toPromise(),
      message: await this.translate.get(msg).toPromise(),
      position: getToastPosition(this.platform),
      duration: 4000
    });
    await toast.present();
  }
}
